import request from '@/utils/request'

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function getUsers(params) {
  return request({
    url: '/user/user',
    method: 'get',
    params
  })
}

export function getUser(params) {
  return request({
    url: '/user/user/' + params,
    method: 'get'
  })
}

export function postUser(data) {
  return request({
    url: '/user/user',
    method: 'post',
    data
  })
}

export function putUser(data) {
  return request({
    url: '/user/user',
    method: 'put',
    data
  })
}

export function delUsers(params) {
  return request({
    url: '/user/user',
    method: 'delete',
    params
  })
}

export function getOrgUser(params) {
  return request({
    url: '/user/orgusers',
    method: 'get'
  })
}

export function addOrgUser(data) {
  return request({
    url: '/user/users',
    method: 'post',
    data
  })
}

export function getCaptcha() {
  return request({
    url: '/user/captcha',
    method: 'get',
    tips: 0
  })
}

export function accountLogin(data) {
  return request({
    url: '/user/accountlogin',
    method: 'post',
    tips: 0,
    data
  })
}
